"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const respinner_1 = require("respinner");
const lib_1 = require("../../lib");
const CircularLoader = respinner_1.CircularLoading;
const BeatLoader = respinner_1.BeatLoading;
const Spinner = ({ className, delay, type, size, relative, }) => {
    const [show, setShow] = (0, react_1.useState)(delay === undefined);
    function handleDelay() {
        setShow(true);
    }
    (0, react_1.useEffect)(() => {
        if (delay !== undefined) {
            const timeout = setTimeout(handleDelay, delay);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, []);
    if (!show) {
        return null;
    }
    if (!type)
        type = "spinner";
    let sizeVal = 20;
    switch (size) {
        case "1":
            sizeVal = 10;
            break;
        case "2":
            sizeVal = 20;
            break;
        case "3":
            sizeVal = 30;
            break;
        case "4":
            sizeVal = 40;
            break;
        case "5":
            sizeVal = 50;
            break;
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)(className, (0, lib_1.bem)("spinner", (0, lib_1.use)(relative, "--relative"))) }, { children: [type === "beat" && ((0, jsx_runtime_1.jsx)(BeatLoader, { count: 4, size: sizeVal, className: (0, lib_1.bem)("spinner__svg", "--beat") }, void 0)), type === "spinner" && ((0, jsx_runtime_1.jsx)(CircularLoader, { duration: 1, className: (0, lib_1.bem)("spinner__svg", "--circular") }, void 0))] }), void 0));
};
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map